import { render, staticRenderFns } from "./XingWeiView.vue?vue&type=template&id=7ab7971b&scoped=true"
import script from "./XingWeiView.vue?vue&type=script&lang=js"
export * from "./XingWeiView.vue?vue&type=script&lang=js"
import style0 from "./XingWeiView.vue?vue&type=style&index=0&id=7ab7971b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab7971b",
  null
  
)

export default component.exports